import { render, staticRenderFns } from "./DeviceView.vue?vue&type=template&id=1ca6ed1d&scoped=true"
import script from "./DeviceView.vue?vue&type=script&lang=js"
export * from "./DeviceView.vue?vue&type=script&lang=js"
import style0 from "./DeviceView.vue?vue&type=style&index=0&id=1ca6ed1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca6ed1d",
  null
  
)

export default component.exports